import React, { useContext, useEffect, useState } from 'react'
import { BreadCrumb } from "primereact/breadcrumb";
import { Sidebar } from "primereact/sidebar";
import { Link, useNavigate } from 'react-router-dom';
import UserMenuComponent from './UserMenuComponent';
import UserSideBarComponent from './UserSideBarComponent';
import DataAPI from '../../api/DataApi';
import CompanyDataType from '../../types/web/companyDataType';
import { LoginContext } from '../../context/LoginContext';
import webLogin from '../../types/webLogin';

function UserContainerComponent(props: any) {
    const navigate = useNavigate();
    const [loading, setloading] = useState(true);
    const [ data, setData ] = useState(new CompanyDataType());
    const defaultLoginContext = useContext(LoginContext);

    useEffect(() => {
        if ( loading ) {
            
            let token: any = localStorage.getItem('token');
            
            let companyData = new CompanyDataType();

            if ( defaultLoginContext === undefined || 
                 defaultLoginContext.webLoginContextValue === undefined || 
                 defaultLoginContext.webLoginContextValue === null ||
                 defaultLoginContext.webLoginContextValue.loaded === false ) {
                
                

                DataAPI.validaLogin(token).then((data) => {
                    
                    if ( data.resultado === 0 ) {
                        navigate('/login');
                    } else {
                        let newLogin: webLogin = new webLogin();
                        newLogin.isLogin = true;
                        newLogin.token = token;
                        newLogin.administrator = data.objeto.ADMINISTRADOR;
                        newLogin.lastCheck = new Date();
                        
                        let minutes: Date = new Date();
                        minutes.setMinutes(newLogin.lastCheck.getMinutes() + 10);
                        newLogin.validationDate = minutes;
                        newLogin.loaded = true;

                        DataAPI.getCompanyData(newLogin.token).then((dataSrv)=> {
                            if ( dataSrv.resultado === 1 ) {
                                localStorage.setItem('company', JSON.stringify(dataSrv.objeto));
                                newLogin.companyName = dataSrv.objeto.name;
                                newLogin.userName = dataSrv.objeto.username;
                                
                                companyData.name = newLogin.companyName;
                                companyData.username = newLogin.userName;
                                
                                setData(companyData);
                                defaultLoginContext?.setWebLoginContextValue(newLogin);
                                setloading(false);
                            } else {
                                defaultLoginContext?.setWebLoginContextValue(newLogin);
                                setloading(false);
                            }
                        });
                    }
                });
            } else {
                let newLogin: webLogin = defaultLoginContext?.webLoginContextValue;

                

                if ( defaultLoginContext.webLoginContextValue.isLogin === false ) {
                    navigate('/login');
                } else {
                    if (newLogin.companyName === "") {
                        DataAPI.getCompanyData(newLogin.token).then((dataSrv)=> {
                            if ( dataSrv.resultado === 1 ) {
                                localStorage.setItem('company', JSON.stringify(dataSrv.objeto));
                                newLogin.companyName = dataSrv.objeto.name;
                                newLogin.userName = dataSrv.objeto.username;
                                
                                companyData.name = newLogin.companyName;
                                companyData.username = newLogin.userName;
                                
                                setData(companyData);
                                defaultLoginContext?.setWebLoginContextValue(newLogin);
                                setloading(false);
                            } else {
                                defaultLoginContext?.setWebLoginContextValue(newLogin);
                                setloading(false);
                            }
                        });
                    } else {
                        
                        companyData.name = defaultLoginContext.webLoginContextValue.companyName;
                        companyData.username = defaultLoginContext.webLoginContextValue.userName;
                        
                        setData(companyData);
                    }                    
                }
            }
            
            
            // if ( token !== undefined ) {
            //     let companyJson: Nullable<string> = localStorage.getItem('company');
            //     if ( companyJson !== undefined && companyJson !== null ) {
            //         companyData = JSON.parse(companyJson);
            //     }
            //     setData(companyData);

            //     DataAPI.getCompanyData(token).then((dataSrv)=> {
            
            //         if ( dataSrv.resultado === 0 ) {
            //             localStorage.removeItem('token');
            //             navigate('/login');
            //         } else {
            //             localStorage.setItem('company', JSON.stringify(dataSrv.objeto))
            //             setData(dataSrv.objeto);
            //         }
            //         setloading(false);
            //     });
            // } else {
            //     navigate('/login');
            // }
        }
    }, [loading, navigate, defaultLoginContext]);

    const iconItemTemplate = (item: any, options: any) => {
        return (
            <Link to={''} className="header-link text-dsGray">
                <span className={item.icon}></span> { item.label }
            </Link>
        );
    };
    const customIcons = (
        <React.Fragment>
            {/* <Link to="/" style={{ textDecoration: 'none' }} className='flex flex-row w-full bg-white'>
                <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                    <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                    <p className='p-0 m-0 uppercase'>Autoneg</p> 
                    <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                </div>
            </Link> */}
        </React.Fragment>
    );

    // const customHeader = (
    //     <div className="flex align-items-center gap-2">
    //         <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
    //         <span className="font-bold">Amy Elsner</span>
    //     </div>
    // );
    // const items = [
    //     { label: 'Home', template: iconItemTemplate },
    //     { label: 'Link', template: iconItemTemplate }
    // ];
    const items: any = [];
    const home = { icon: 'pi pi-home', url: '/', color: 'red' };
    const [ visible, setVisible ] = useState(false);

    return (
        <div className='flex flex-col lg:flex-row h-dvh lg:overflow-y-hidden w-full min-w-[330px]'>
            
            {/* sidebar */}
            <div className='hidden lg:block w-2/12 xl:w-2/12 bg-dsdark user-home-navbar-effects text-white'>
                {/* logo */}
                {/* <div className='flex w-full justify-center p-4 text-center'>
                    <Link to={'/'}>
                        <img className='w-4/5 h-auto' src="assets/img/logobig.png" alt="" />
                    </Link>
                </div> */}
                <div className='bg-dsgray user-home-navbar-effects min-h-[56px] xl:min-h-[75px] xl:max-h-[75px]'>
                    <a href={'/'} className='' style={{ textDecoration: 'none' }}>
                        <div className=' pt-2 text-lg 2xl:text-4xl py-0 font-bold text-dsBlue font-Roboto w-full text-center flex items-center justify-center'>
                            <img src="/assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                            <p className='p-0 m-0 uppercase'>Autoneg</p> 
                            <span className='font-Roboto self-end text-red-700 text-[8px] xl:text-sm'>&nbsp;3.0</span>
                        </div>
                        <div className=' text-md 2xl:text-xl py-0 font-bold text-green-800 font-Roboto w-full text-center'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                    </a>
                </div>
                {/* menu */}
                <div className='mt-8 px-3 xl:px-6 w-full '>
                    <UserMenuComponent loginContext = {defaultLoginContext?.webLoginContextValue} />
                </div>
            </div>
            {/* content */}
            <div className='w-full lg:w-10/12 xl:w-10/12 bg-dsgray overflow-y-auto h-full flex flex-col'>
                {/* <div className='w-full min-h-full flex flex-col' > */}

                    <div className=' lg:hidden bg-dsgray' style={{ paddingBottom: '15px' }}>
                        <div className='bg-dsgray user-home-navbar-effects flex flex-col'>
                            <div className='relative top-5'><i onClick={() => { setVisible(true); }} className="material-icons-outlined md-24 absolute left-5 ">menu</i></div>
                            {/* MOBILE */}
                            <a href={'/'} className='contents w-fit' style={{ textDecoration: 'none' }}>
                                <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                                    <img src="/assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                                    <p className='p-0 m-0 uppercase'>Autoneg</p> 
                                    <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                                </div>
                            </a>
                            <div className='self-center text-xl py-0 font-bold text-green-800 font-Roboto text-center'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                            <div className='text-xl py-0 text-dsGray font-bold font-Roboto text-center'>{ defaultLoginContext?.webLoginContextValue?.companyName }</div>
                        </div>
                    </div>
                    
                    <div className='hidden px-8 xl:py-2 ds-container-bottom-shadow lg:flex sticky top-0 z-[990] bg-dsgray min-h-[56px] xl:min-h-[75px] xl:max-h-[75px] items-center'>
                        {/* <div className='text-4xl py-0 font-bold text-dsGray font-Roboto'>Facturacion <span className='text-dsGray'>Electronica</span></div> */}
                        <div className='w-8/12 flex flex-col space-y-1'>
                        <div className='text-md xl:text-3xl py-0 text-dsBlue font-bold font-Roboto'>{ defaultLoginContext?.webLoginContextValue?.companyName }</div>
                            <div className=''>
                                <BreadCrumb className='bg-dsgray font-bold border-0 py-0 px-0 text-xs xl:text-base' model={items} home={home} />   
                            </div>
                        </div>
                        <div className='w-4/12  flex flex-col space-y-1'>
                            <div className='text-dsBlue font-bold text-sm xl:text-lg truncate w-full text-right'>{defaultLoginContext?.webLoginContextValue?.userName}</div>
                            <div className='w-full '>
                                <Link onClick={cerrarSesion} className='flex items-center text-[10px] xl:text-sm text-red-700 font-bold ds-link-default text-right justify-end ' to={''}>
                                    <i className="material-icons-outlined md-18">logout</i>
                                    Cerrar Sesi&oacute;n
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='flex-auto'>
                        { props.children }
                    </div>
                    <div className=' lg:min-h-[25px] px-4 text-dsGray font-bold flex flex-col lg:flex-row lg:justify-between space-y-0 py-2 lg:py-0 lg:my-2 justify-center text-center'>
                        {/* <p className='m-0'>{new Date().getFullYear()} &copy; Racol Computers S.R.L.</p> */}
                        <p className='m-0'>&nbsp;</p>
                        <p>Desarrollado Por Brian Almengo</p>
                    </div>
                {/* </div> */}
            </div>
            <div className="card flex justify-content-center">
                <Sidebar className='bg-gray-default p-sidebar-header-teamsidemenu xs:w-4/5 sm:w-2/5 md:1/5' 
                    visible={visible} onHide={() => setVisible(false)}
                    icons = { customIcons } 
                    style={ { backgroundColor: '#282c34' } }
                    content={({ closeIconRef, hide }) => (
                        <UserSideBarComponent 
                            userName={String(defaultLoginContext?.webLoginContextValue?.userName)} 
                            loginContext = {defaultLoginContext?.webLoginContextValue}
                            />
                    )}>
                </Sidebar>                    
            </div>
        </div>
    );

    function cerrarSesion() {
        localStorage.removeItem('token');
        localStorage.removeItem('company');
        navigate('/login');
    }
}

export default UserContainerComponent;